var map = {
	"./CLUB-1.svg": 355,
	"./CLUB-10.svg": 777,
	"./CLUB-11-JACK.svg": 5072,
	"./CLUB-12-QUEEN.svg": 7266,
	"./CLUB-13-KING.svg": 5974,
	"./CLUB-2.svg": 3312,
	"./CLUB-3.svg": 8849,
	"./CLUB-4.svg": 5470,
	"./CLUB-5.svg": 2847,
	"./CLUB-6.svg": 172,
	"./CLUB-7.svg": 3293,
	"./CLUB-8.svg": 6618,
	"./CLUB-9.svg": 6987,
	"./DIAMOND-1.svg": 8901,
	"./DIAMOND-10.svg": 5087,
	"./DIAMOND-11-JACK.svg": 750,
	"./DIAMOND-12-QUEEN.svg": 9712,
	"./DIAMOND-13-KING.svg": 9296,
	"./DIAMOND-2.svg": 9766,
	"./DIAMOND-3.svg": 7303,
	"./DIAMOND-4.svg": 7496,
	"./DIAMOND-5.svg": 2361,
	"./DIAMOND-6.svg": 7274,
	"./DIAMOND-7.svg": 6331,
	"./DIAMOND-8.svg": 8684,
	"./DIAMOND-9.svg": 8397,
	"./HEART-1.svg": 2613,
	"./HEART-10.svg": 207,
	"./HEART-11-JACK.svg": 4990,
	"./HEART-12-QUEEN.svg": 7040,
	"./HEART-13-KING.svg": 7184,
	"./HEART-2.svg": 3478,
	"./HEART-3.svg": 1015,
	"./HEART-4.svg": 1208,
	"./HEART-5.svg": 6073,
	"./HEART-6.svg": 986,
	"./HEART-7.svg": 43,
	"./HEART-8.svg": 2396,
	"./HEART-9.svg": 2109,
	"./JOKER-1.svg": 9352,
	"./JOKER-2.svg": 91,
	"./JOKER-3.svg": 5482,
	"./SPADE-1.svg": 8374,
	"./SPADE-10.svg": 6666,
	"./SPADE-11-JACK.svg": 6293,
	"./SPADE-12-QUEEN.svg": 1753,
	"./SPADE-13-KING.svg": 39,
	"./SPADE-2.svg": 5013,
	"./SPADE-3.svg": 7028,
	"./SPADE-4.svg": 4731,
	"./SPADE-5.svg": 5914,
	"./SPADE-6.svg": 5209,
	"./SPADE-7.svg": 2840,
	"./SPADE-8.svg": 4815,
	"./SPADE-9.svg": 8414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5785;